import axios from '../../http';

const state = {
  tariffDetails: {
    tariffDetails: []
  },
  existingProjection: {
    electricityChosenPersonalProjectionPlan: null,
    electricityDefaultPersonalProjectionPlan: null,
    gasChosenPersonalProjectionPlan: null,
    gasDefaultPersonalProjectionPlan: null
  },
  newProjection: {
    electricityChosenPersonalProjectionPlan: null,
    electricityDefaultPersonalProjectionPlan: null,
    gasChosenPersonalProjectionPlan: null,
    gasDefaultPersonalProjectionPlan: null
  },
  newTil: {
    electricityTariffInformationLabel: null,
    gasTariffInformationLabel: null
  },
  existingTil: {
    electricityTariffInformationLabel: null,
    gasTariffInformationLabel: null
  }
};

const getters = {};

const actions = {
  async getTariffDetails ({ rootState, commit, dispatch }, tariffId) {
    const { switchId, switchType, proposedPayMethod } = rootState.storage.quote;

    dispatch('page_loader/start', 0, { root: true });

    try {
      const tariffDetailsResponse = await axios({
        method: 'POST',
        url: '/request/tariffs/tariff/information',
        data: { tariffId }
      });
      const model = {
        proposedPayMethod,
        switchId,
        switchType,
        tariffId,
        tariffValidToDate: null
      };

      const existingTilResponse = await axios({
        method: 'POST',
        url: '/request/til',
        data: {
          onCurrentTariff: true,
          ...model
        }
      });

      const newTilResponse = await axios({
        method: 'POST',
        url: '/request/til',
        data: {
          onCurrentTariff: false,
          ...model
        }
      });

      const existingProjectionResponse = await axios({
        method: 'POST',
        url: '/request/ppp',
        data: {
          onCurrentTariff: true,
          ...model
        }
      });

      const newProjectionResponse = await axios({
        method: 'POST',
        url: '/request/ppp',
        data: {
          onCurrentTariff: false,
          ...model
        }
      });

      commit('updateState', {
        prop: 'tariffDetails',
        value: tariffDetailsResponse.data.tariffInfoDto
      });

      commit('updateState', {
        prop: 'newProjection',
        value: newProjectionResponse.data.pppDto
      });

      commit('updateState', {
        prop: 'existingProjection',
        value: existingProjectionResponse.data.pppDto
      });

      commit('updateState', {
        prop: 'existingTil',
        value: existingTilResponse.data.tilDto
      });

      commit('updateState', {
        prop: 'newTil',
        value: newTilResponse.data.tilDto
      });

      dispatch('page_loader/stop', null, { root: true });
      return res;
    } catch (error) {
      dispatch('page_loader/stop', null, { root: true });
      return error;
    }
  }
};

const mutations = {
  updateState (state, { prop, value }) {
    state[prop] = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
